import { ResultResponse } from "src/models/BaseModel";
import {
  Configuration,
  UpdateConfigurationBody,
} from "src/models/ConfigurationModel";
import { PrivateApi } from "./BaseApi";

export const configurationApi = PrivateApi.injectEndpoints({
  endpoints: (builder) => ({
    getConfigurations: builder.query<
      ResultResponse<Configuration[]>,
      Record<string, any>
    >({
      query: (params) => ({
        url: "Configurations/GetAllConfigurations",
        method: "GET",
        params,
      }),
      providesTags: ["Configurations"],
    }),
    getConfigurationByKey: builder.query<
      ResultResponse<Configuration>,
      { key: string }
    >({
      query: (params) => ({
        url: "Configurations/GetConfigurationByKey",
        method: "GET",
        params,
      }),
    }),
    setConfiguration: builder.mutation<
      ResultResponse<Configuration>,
      UpdateConfigurationBody
    >({
      invalidatesTags: ["Configurations"],
      query: (body) => ({
        url: "Configurations/SetConfigurationByKey",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetConfigurationsQuery,
  useGetConfigurationByKeyQuery,
  useSetConfigurationMutation,
} = configurationApi;
